import { FOCUS_ACTION } from './focusActions';

/**
 *  We can't use a boolean to track whether the text box is focused, because then
  * we would have to set the state to false when the user de-focuses the text box.
  * Use a counter instead, and if the the counter increases, then we know we should set focus on the text box.
  */

const initialState = 0;

export const focusCounterReducer = (state = initialState, action) => {
    switch (action.type) {
        case FOCUS_ACTION:
            return state + 1;
        default:
            return state;
    }
};
